// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#408ca8", // Custom primary color (purple)
        },
        secondary: {
            main: "#96e3ff", // Custom secondary color (teal)
        },
        custom: {
            main: "#ff5722", // Custom color (orange)
            contrastText: "#fff", // Text color for this custom button
        },
    },
    typography: {
        fontFamily: "'Roboto', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8, // Example global button styling
                    textTransform: "none", // Prevents uppercase text
                },
            },
        },
    },
});

export default theme;
